import React from 'react';
import { Icon } from '@ihsm/ui-shared';
import { MessageIconProps } from '../types';

export const MessageIcon = ({ type }: MessageIconProps): JSX.Element => {
  if (type === 'error') {
    return <Icon source="Error" />;
  }

  if (type === 'success') {
    return <Icon source="Tick" />;
  }

  if (type === 'info') {
    return <Icon source="Info" />;
  }

  return <></>;
};
